import type { Writable } from 'svelte/store';

export const createUpdater = <T>(store: Writable<T>, defaultValue: T) => {
  return (update: Partial<T>): T => {
    let result: T | undefined;
    store.update((current) => {
      result = { ...defaultValue, ...current, ...update };
      return result;
    });
    if (result === undefined) {
      throw new Error('unexpected error: updater returned undefined');
    }
    return result as T;
  };
};

export const createResetter = <T>(store: Writable<T>, defaultValue: T) => {
  return () => {
    store.set(defaultValue);
  };
};
